import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, createSlots as _createSlots } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = { key: 0 };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("span", { class: "text-caption text-jetBlack" }, "Alt: ", -1);
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
    key: 0,
    class: "cCode"
};
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("span", { class: "text-caption text-jetBlack" }, "Condition:", -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_8 = {
    key: 0,
    class: "totalQty"
};
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("span", { class: "text-caption text-jetBlack" }, "Total qty:", -1);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_11 = {
    key: 2,
    class: "totalQty"
};
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("span", { class: "text-caption text-jetBlack" }, "Qty:", -1);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_14 = { key: 0 };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("span", { class: "text-caption text-jetBlack" }, "Serial No: ", -1);
const _hoisted_16 = ["innerHTML"];
const _hoisted_17 = { key: 1 };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("span", { class: "text-caption text-jetBlack" }, "Document: ", -1);
const _hoisted_19 = { class: "text-brown" };
const _hoisted_20 = { key: 2 };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("span", { class: "text-caption text-jetBlack" }, "Quantity: ", -1);
const _hoisted_22 = ["innerHTML"];
const _hoisted_23 = ["innerHTML"];
import { getConditionColor } from './sp';
import BundledPartsList from './BundledPartsList.vue';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SparePartCard',
    props: {
        sparePart: {},
        config: {},
        checkInQuote: {},
        primarySparePart: {},
        showBundled: { type: Boolean, default: true }
    },
    emits: ["toggleSparePart"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const showBundledSparePart = ref(null);
        return (_ctx, _cache) => {
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_tooltip = _resolveComponent("v-tooltip");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_card_actions = _resolveComponent("v-card-actions");
            const _component_v_card = _resolveComponent("v-card");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_component_v_card, {
                    variant: "elevated",
                    height: "100%"
                }, _createSlots({
                    default: _withCtx(() => [
                        _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => {
                                var _a;
                                return [
                                    (_ctx.sparePart.serial_number)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                            _hoisted_15,
                                            _createElementVNode("b", {
                                                class: "text-duskBlue",
                                                innerHTML: _ctx.sparePart.metadata.serial_number_html || _ctx.sparePart.serial_number
                                            }, null, 8, _hoisted_16)
                                        ]))
                                        : _createCommentVNode("", true),
                                    (['SV', 'NE', 'OH'].includes(_ctx.sparePart.condition_code) && _ctx.sparePart.document)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                            _hoisted_18,
                                            _createElementVNode("b", _hoisted_19, [
                                                _createTextVNode(_toDisplayString(_ctx.sparePart.document), 1),
                                                (_ctx.sparePart.doc_date)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createTextVNode(" (" + _toDisplayString(_ctx.sparePart.doc_date) + ")", 1)
                                                    ], 64))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    (_ctx.config.bundle_mode)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                            _hoisted_21,
                                            _createElementVNode("b", {
                                                class: "text-duskBlue",
                                                innerHTML: _ctx.sparePart.quantity
                                            }, null, 8, _hoisted_22)
                                        ]))
                                        : _createCommentVNode("", true),
                                    (!_ctx.sparePart.is_bundled || (_ctx.sparePart.description !== ((_a = _ctx.primarySparePart) === null || _a === void 0 ? void 0 : _a.description)))
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 3,
                                            class: "sparePart-descr",
                                            innerHTML: _ctx.sparePart.metadata.description_html || _ctx.sparePart.description
                                        }, null, 8, _hoisted_23))
                                        : _createCommentVNode("", true)
                                ];
                            }),
                            _: 1
                        }),
                        _createVNode(_component_v_card_actions, { class: "bg-warmLightGray-lighten" }, {
                            default: _withCtx(() => [
                                (_ctx.checkInQuote(_ctx.sparePart))
                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 0,
                                        "prepend-icon": "mdi-minus",
                                        density: "comfortable",
                                        color: "vibrantRed",
                                        title: "Remove from quote",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (emit('toggleSparePart', _ctx.sparePart)))
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(" Remove ")
                                        ]),
                                        _: 1
                                    }))
                                    : (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 1,
                                        "prepend-icon": "mdi-plus",
                                        density: "comfortable",
                                        color: "jetBlack",
                                        title: "Add to quote",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (emit('toggleSparePart', _ctx.sparePart)))
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(" Quote ")
                                        ]),
                                        _: 1
                                    })),
                                (_ctx.config.bundle_mode && _ctx.showBundled && _ctx.sparePart.bundled.length)
                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 2,
                                        "prepend-icon": "mdi-unfold-more-horizontal",
                                        density: "comfortable",
                                        color: "duskBlue",
                                        onClick: _cache[2] || (_cache[2] = ($event) => (showBundledSparePart.value = _ctx.sparePart))
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(" Show " + _toDisplayString(_ctx.sparePart.bundled.length) + " more ", 1)
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        })
                    ]),
                    _: 2
                }, [
                    (!_ctx.sparePart.is_bundled)
                        ? {
                            name: "title",
                            fn: _withCtx(() => [
                                _createElementVNode("span", {
                                    innerHTML: _ctx.sparePart.metadata.part_number_html || _ctx.sparePart.part_number
                                }, null, 8, _hoisted_1)
                            ]),
                            key: "0"
                        }
                        : undefined,
                    (!_ctx.sparePart.is_bundled)
                        ? {
                            name: "subtitle",
                            fn: _withCtx(() => [
                                (_ctx.sparePart.part_number_alt_1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                        _hoisted_3,
                                        _createElementVNode("span", {
                                            innerHTML: _ctx.sparePart.metadata.part_number_alt_1_html || _ctx.sparePart.part_number_alt_1
                                        }, null, 8, _hoisted_4)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            key: "1"
                        }
                        : undefined,
                    (!_ctx.sparePart.is_bundled)
                        ? {
                            name: "append",
                            fn: _withCtx(() => [
                                (_ctx.sparePart.condition_code)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _hoisted_6,
                                        _hoisted_7,
                                        _createVNode(_component_v_chip, {
                                            color: _unref(getConditionColor)(_ctx.sparePart.condition_code),
                                            variant: "tonal",
                                            size: "small"
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("b", null, _toDisplayString(_ctx.sparePart.condition_code), 1)
                                            ]),
                                            _: 1
                                        }, 8, ["color"]),
                                        _createVNode(_component_v_tooltip, {
                                            activator: "parent",
                                            location: "bottom"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.config.conditions.find(c => c.code === _ctx.sparePart.condition_code).label), 1)
                                            ]),
                                            _: 1
                                        })
                                    ]))
                                    : _createCommentVNode("", true),
                                (_ctx.config.bundle_mode)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (_ctx.sparePart.total_quantity > 1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                _hoisted_9,
                                                _hoisted_10,
                                                _createVNode(_component_v_chip, {
                                                    color: "duskBlue",
                                                    variant: "outlined",
                                                    size: "small"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.sparePart.total_quantity), 1)
                                                    ]),
                                                    _: 1
                                                })
                                            ]))
                                            : _createCommentVNode("", true)
                                    ], 64))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _hoisted_12,
                                        _hoisted_13,
                                        _createVNode(_component_v_chip, {
                                            color: "duskBlue",
                                            variant: "outlined",
                                            size: "small"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.sparePart.quantity), 1)
                                            ]),
                                            _: 1
                                        })
                                    ]))
                            ]),
                            key: "2"
                        }
                        : undefined
                ]), 1024),
                _createVNode(BundledPartsList, {
                    "primary-spare-part": showBundledSparePart.value,
                    "onUpdate:primarySparePart": _cache[3] || (_cache[3] = ($event) => ((showBundledSparePart).value = $event)),
                    config: _ctx.config,
                    checkInQuote: _ctx.checkInQuote,
                    onToggleSparePart: _cache[4] || (_cache[4] = ($event) => (emit('toggleSparePart', $event)))
                }, null, 8, ["primary-spare-part", "config", "checkInQuote"])
            ], 64));
        };
    }
});
